module.exports = `${require.publicPath}icon17.4ef7e77e.png`;